import './subheading.scss';

const Subheading = ({ children, id=undefined }) => {
    return <h2 id={id} className='onboard-subheading'>{children}</h2>
}

export default Subheading;